import styled from "styled-components";

export const Container = styled.div`
  margin: 0 12px;
`;

export const ContainerUpper = styled.div``;
export const EntriesTable = styled.table`
  margin: 0 -12px;
  width: calc(100% + 24px);
  td {
    vertical-align: top;
  }
  tr > *:first-child {
    padding-left: 12px;
  }
  tr > *:last-child {
    padding-right: 12px;
  }
  tbody th {
    font-weight: normal;
  }
  tbody td,
  tbody th {
    padding: 4px;
    border-bottom: 1px solid #00000022;
  }
  tr.selected {
    position: relative;
  }
  tr.selected > * {
    background-color: #ffffce;
  }
  tr.selected th .name {
    font-weight: bold;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  tr th .name small {
    color: #0008;
    line-height: 1;
    margin-top: -2px;
    margin-bottom: 3px;
    display: block;
    font-weight: normal;
  }
  td.score,
  th.score,
  td.position,
  th.position {
    text-align: right;
    line-height: 40px;
  }
  td.score,
  th.score {
    width: 60px;
  }
  th.position,
  td.position {
    width: 45px;
  }
  td.score-tuple,
  th.score-tuple {
    width: 25px;
    box-sizing: content-box;
    line-height: 40px;
  }
  tbody th > div {
    display: flex;
    align-items: center;
  }
  div.avatar {
    margin-right: 6px;
  }
  div.info {
    display: block;
    font-size: 13px;
    color: #0008;
    strong {
      color: black;
      font-weight: normal;
    }
  }
  .actions {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #00000018;
  }
`;

export const BottomSheetTitle = styled.h6`
  font-weight: bold;
  padding: 0 12px;
  text-align: center;
`;

export const BottomSheetMenu = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const BottomSheetText = styled.div`
  text-align: center;
`;

export const BottomSheetMenuItem = styled.button`
  appearance: none;
  border: none;
  background: white;
  padding: 12px;
  &.danger {
    color: red;
  }
  &.cancel {
    color: #00000088;
  }
`;

export const Instruction = styled.div`
  color: white;
  background: radial-gradient(
    100% 2434.05% at 2.19% 0%,
    #2c8dff 0%,
    #0075ff 100%
  );
  margin: 8px;
  padding: 12px;
  border-radius: 12px;
  position: sticky;
  left: 0;
  top: 70px;
  right: 0;
  z-index: 2;
  box-shadow: 0 0 30px 20px white;
  a {
    color: #000000aa;
    text-decoration: none;
    font-weight: bold;
    margin-left: 10px;
  }
`;

export const AccountSummaryInline = styled.div`
  display: inline-block;
  background: #ffffce;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #00000011;
  margin: 4px 0;

  strong {
    display: inline-flex;
    align-items: center;
    span {
      margin-left: 4px;
      display: inline-block;
    }
  }

  .sep {
    color: #00000055;
    margin: 0 5px;
  }
`;
